import {Box, Typography} from "@mui/material";
import {useAppDispatch, useAppSelector} from "../app/store/hooks.ts";
import {useEffect} from "react";
import {setPopUpOpen} from "../app/store/slices/appSlice.ts";
import {liquidGlassStyle} from "../app/theme/liquidGlassStyle.ts";

interface IPopUpProps {

}

export const PopUp = ({}: IPopUpProps) => {
    const dispatch = useAppDispatch();
    const safeArea = useAppSelector((state) => state.app.safeArea);
    const isPopUpOpen = useAppSelector((state) => state.app.isPopUpOpen);

    useEffect(() => {
        if (!isPopUpOpen.isOpen) return;
        const timer = setTimeout(() => {
            dispatch(setPopUpOpen({isOpen: false, message: null}));
        }, 3000);
        return () => clearTimeout(timer);
    }, [isPopUpOpen]);

    if (!isPopUpOpen.isOpen || !isPopUpOpen.message) {
        return null;
    }


    return (
        <Box position={'fixed'} top={`calc(${safeArea.top}px + 60px)`} zIndex={1000} justifyContent={'center'}
             alignItems={'center'} display={'flex'} width={'100%'}>
            <Box
                sx={{
                    ...liquidGlassStyle,
                    borderRadius: '24px',
                    textTransform: 'none',
                    padding: '8px 16px',
                    maxWidth: '70vw',
                    textAlign: 'center'
                }}>
                <Typography variant="h6" sx={{fontWeight: '800', opacity: 0.8}}>{isPopUpOpen.message}</Typography>
            </Box>
        </Box>
    )
};
